import { formatNumber } from '@/shared/utils/number-format';

export function fmtMoney(n: number, compact = true): string {
  if (compact && Math.abs(n) >= 1000) {
    const v = n / 1000;
    return formatNumber(v, 1) + 'K';
  }
  return formatNumber(Math.round(n), 0);
}

export function fmtCount(n: number): string {
  return formatNumber(Math.round(n), 0);
}

export function fmtPct(n: number): string {
  return formatNumber(n, 1);
}

export function fmtDateShort(d: Date): string {
  const months = ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  return d.getDate() + ' ' + months[d.getMonth()];
}

export function fmtDateLong(d: Date): string {
  const days = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  return days[d.getDay()] + ' · ' + fmtDateShort(d);
}

export function isoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return y + '-' + m + '-' + day;
}

export function startOfDay(d: Date = new Date()): Date {
  const r = new Date(d);
  r.setHours(0, 0, 0, 0);
  return r;
}

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}
